import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  PdfGetRelatedPartyDetailsPdfRequest,
  PdfGetStaticPdfRequest,
  ResponseError,
  ResultOfReportObject,
  useApiClient
} from 'bff';

export const useGetStaticPdf = (
  options?: UseMutationOptions<Blob, ResponseError, PdfGetStaticPdfRequest>
) => {
  const { pdfApi } = useApiClient();
  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['useGetStaticPdf'],
    mutationFn: (getStaticPdfRequest) => pdfApi.pdfGetStaticPdf(getStaticPdfRequest)
  };
  return useMutation(mutationOptions);
};

export const useGetRelatedPartyDetailsPdf = (
  options?: UseMutationOptions<
    ResultOfReportObject,
    ResponseError,
    PdfGetRelatedPartyDetailsPdfRequest
  >
) => {
  const { pdfApi } = useApiClient();
  const mutationOptions: typeof options = {
    ...options,
    mutationKey: ['useGetStaticPdf'],
    mutationFn: (getRelatedPartyDetailsPdfRequest) =>
      pdfApi.pdfGetRelatedPartyDetailsPdf(getRelatedPartyDetailsPdfRequest)
  };
  return useMutation(mutationOptions);
};
